const powerbiIframe = (that) => {
  if (!cmplz_has_consent('marketing')) {
    return `<iframe data-placeholder-image="${that.getAttribute('data-power-bi-cmplz-placeholder')}" data-category="marketing" data-service="powerbi" class="cmplz-placeholder-element cmplz-iframe cmplz-iframe-styles" data-src-cmplz="${that.getAttribute('href')}" title="${that.getAttribute('data-power-bi-title')}" data-components--power-bi-target="report" frameborder="0" allowFullScreen="false"></iframe>`;
  } else {
    return `<iframe src="${that.getAttribute('href')}" frameborder="0" title="${that.getAttribute('data-power-bi-title')}" data-components--power-bi-target="report" allowFullScreen=\"false\"></iframe>`;
  }
}

export const powerbiComponent = (that) => {
  return "<div class=\"component-power-bi\" data-controller=\"components--power-bi\">\n    <div class=\"component-power-bi--report\">\n" + (powerbiIframe(that)) + "\n</div>\n</div>";
}
